import script from "./left.vue?vue&type=script&setup=true&name=layout_left&lang=js"
export * from "./left.vue?vue&type=script&setup=true&name=layout_left&lang=js"

import "./left.vue?vue&type=style&index=0&id=71252327&scoped=true&lang=css"

import exportComponent from "E:\\SYH-SPMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71252327"]])

export default __exports__